/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.198.0-v202609241235-CDH
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

/**
 * The list of searches for finding items based on a materialized table's UUID column
 */
export interface ScalingTableUUIDColumnSearchV1 {
    /**
     * The column definition ID whose items will be searched
     */
    "columnDefinitionId": string;
    /**
     * If true, the items found by this search will be included in the output. If false, then the results will be excluded from the output (even if found by another search)
     */
    "isInclude": boolean;
    /**
     * Whether this Scaling Table search should be used to add items to a Tree Builder Table
     */
    "pathOverride"?: boolean;
    /**
     * The row ids, either the item ids that identify the rows of the table or the item id and datum id pair separated by '|', that filter the search to only those rows.
     */
    "rowIds"?: Array<string>;
    /**
     * The priority of this search. Searches execute in descending order value, so when the same item appears in multiple searches, the search with the lowest order value executes last and wins. If not specified, the search is treated as the lowest priority and executes first. Searches with the same order value (or none) execute in ascending ID order, so the search with the higher ID wins (deterministic).
     */
    "searchOrder"?: number;
    /**
     * The type of search
     */
    "searchType": SearchTypeEnum;
    /**
     * The table definition ID whose column items will be searched
     */
    "tableDefinitionId": string;
    /**
     * The types of items that will be searched, defaults to all types if not provided
     */
    "types"?: Array<string>;
}

export const SearchTypeEnum = {
    SWAPACROSSASSETS: 'SWAP_ACROSS_ASSETS',
    FIXEDLIST: 'FIXED_LIST',
    PROPERTY: 'PROPERTY',
    MATERIALIZEDTABLEUUIDCOLUMN: 'MATERIALIZED_TABLE_UUID_COLUMN',
    HIERARCHY: 'HIERARCHY',
    STOREDTABLE: 'STORED_TABLE'
} as const;

export type SearchTypeEnum = typeof SearchTypeEnum[keyof typeof SearchTypeEnum];
